import React from 'react';
import { HighlightType } from '../Select/types';
import { OverlayPositionType } from '../ThemeProvider/types';

export interface DropdownProps {
  target: string;
  isOpen: boolean;
  options: any[];
  keyProperty?: string;
  showProperty?: string;
  inputValue?: InputValueType | null | any;
  highlightedIndex: HighlightType;
  highlightedSubString?: string;
  scrollRef?: React.RefObject<HTMLInputElement>;
  isValueObject?: boolean;
  chevronRef: React.MutableRefObject<HTMLDivElement>;
  overlayPosition?: OverlayPositionType;
  targetHeight?: number;
  emptyStateLabel?: string;
  overAll?: boolean;
  testId?: string;
  setHighlightedIndex: (value: HighlightType) => void;
  onSelection: (data: InputValueType) => void;
  setIsOpen: (isOpen: boolean) => void;
}

export const OVERLAY_MAX_HEIGHT = 144;

export type InputPositionType = {
  width: number;
  top: number;
  bottom: number;
  x: number;
};

type InputValueType = { from: string; until: string } | string;
